import { useRouter } from 'vue-router';
import { clearDraftsOnSignOut } from '@lumi/app-kit';
import { useAuthStore } from '@/stores/auth';
import { useTenantsStore } from '@/stores/tenants';

// The workspace's ONE way to sign out on purpose: this browser's drafts go
// silently first (app-kit's clearDraftsOnSignOut, no dialog), then the session
// ends and the login page takes over. Shared by the app chrome (sidebar
// button, demo stage bar menu) and the chrome-less first-run fork / demo exit
// gate (#409 follow-ups, D4), so a screen without the sidebar does not grow a
// second sign-out that skips the clear.
export function useSignOut() {
  const router = useRouter();
  const authStore = useAuthStore();
  const tenantsStore = useTenantsStore();

  async function signOut(): Promise<void> {
    clearDraftsOnSignOut(tenantsStore.activeTenant?.slug ?? null, authStore.user?.userId ?? null);
    authStore.logout();
    router.push('/login');
  }

  return { signOut };
}
